import React from 'react'
import { Route } from 'react-router-dom'
import AuthorizedLayout from '../bootstrap/AuthorizedLayout'
import { checkoutRoutes } from './CheckoutRoutes'
import { dashboardRoutes } from './DashboardRoutes'
import { profileRoutes } from './ProfileRoutes'
import { competitionRoutes } from './CompetitionRoutes'
import { editorRoutes } from './EditorRoutes'
import { projectRoutes } from './ProjectRoutes'
import { sharedProjectRoutes } from './SharedProjectRoutes'
import { workspaceRoutes } from './WorkspaceRoutes'

export const protectedRoutes = [
  <Route key='auth' element={<AuthorizedLayout />}>
    {checkoutRoutes}
    {dashboardRoutes}
    {profileRoutes}
    {competitionRoutes}
    {editorRoutes}
    {projectRoutes}
    {sharedProjectRoutes}
    {workspaceRoutes}
  </Route>
]
